import { Account } from '@pages/Trade/types'

import { MT4Icon } from '@ui/icons/platforms/MT4.icon'
import { MT5Icon } from '@ui/icons/platforms/MT5.icon'
import { TMTIcon } from '@ui/icons/platforms/TMT.icon'
import { TradingViewIcon } from '@ui/icons/platforms/TradingView.icon'

import { PlatformTypeEnum } from '@model/PlatformTypeEnum'

export const getLogoForAccount = (account: Account, size = 40) => {
  switch (account.platformType.id) {
    case PlatformTypeEnum.MT4:
      return <MT4Icon size={size} />
    case PlatformTypeEnum.MT5:
      return <MT5Icon size={size} />
    case PlatformTypeEnum.TradingView:
      return <TradingViewIcon size={size} />
    case PlatformTypeEnum.TickmillTrader:
      return <TMTIcon size={size} />
  }
}

export const getTradingAccountIcon = (platformType: PlatformTypeEnum) => {
  switch (platformType) {
    case PlatformTypeEnum.MT4:
      return MT4Icon
    case PlatformTypeEnum.MT5:
      return MT5Icon
    case PlatformTypeEnum.TradingView:
      return TradingViewIcon
    case PlatformTypeEnum.TickmillTrader:
      return TMTIcon
  }
}
